import { ErrorResponse, FgStatusEnum, GlobalStatus, JobCompletedEnum, JobStatusEnum, OperationTypeEnum, Series, UnitRequest, ShiftsEnum, WorkStationTypeEnum } from '@gtpl/shared-models/common-models';
import { BeheadingInventoryDto, BeheadingInventoryResponse, BeheadingReportedQty, InProgressBeHeadingDto, InProgressBeheadingResponse, BeheadingDashboardResponse, ChartInfo, SoakingResponseModel, SoakingDto, LotDetailsResponseModel, LogDetailsResponseModelDto, ProductionLogResponse, OperationsRegisterResponseModel, OperatonsRegisterDto, SubPlantTransferResponse, OperationRegisterRequest, LotNumberReportResponseModel, LotTrackingResponseDto, ProductionLogDetailsResponseModel, ProductionLogDto } from '@gtpl/shared-models/production-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Raw, Repository } from 'typeorm';
import { OperationRequest } from './dto/operation-data.request';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { ProductionLogAdapter } from './dto/production-log.adapter';
import { ProductionLogData } from './dto/production-log.dto';
import { ProductionLogRepository } from './repositories/production-log.repository';
import { WorkstationService } from '@gtpl/shared-services/production';
import { CommonResponse, SaleOrderItemsBySoIdReaponseModel } from '@gtpl/shared-models/sale-management';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { LogIdRequest } from './dto/log-id-request';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { OperationSequenceRequest } from './dto/operation-sequence.request';
import { ProductionLog } from './entities/production-log.entity';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { LotInfoRequest } from './dto/lot-info.request';
import { SubPlantHistoryDto } from 'libs/shared-models/production-management/src/lib/production-log/sub-plant-history.dto';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import appSettings from 'apps/services/config';
import { PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
@Injectable()
export class ProductionLogService {
    constructor(@InjectRepository(ProductionLogRepository)
    private productionLogRepo: ProductionLogRepository,
        @InjectRepository(ProductionInventoryRepository)
        private inventoryRepository: ProductionInventoryRepository,
        @InjectRepository(ProductionLog)
        private productionLogRepository: Repository<ProductionLog>,
        private saleOrderService: SaleOrderService,
        private variantOperationService: VariantOperationsService,
        private unitcodeService: UnitcodeService,
        private workstations: WorkstationService,
        private logAdapter: ProductionLogAdapter) { }

    async CreateProductionLog(inputReq: ProductionLogData) {
        try {
            const convertDtoToEntity = await this.logAdapter.convertDtoToEntity(inputReq);
            const createLog = await this.productionLogRepo.save(convertDtoToEntity);
            // update previous operation status against workstation
            // const updatePreviousOperation = await this.updatePreviousOperationStatus(productionLogData.lotNumber, productionLogData.workStation)
            const savedProdLogDto: ProductionLogData = this.logAdapter.convertEntityToDto(convertDtoToEntity);
            if (savedProdLogDto) {
                // generating resposnse
                const response = new ProductionLogResponse(true, 1, 'ProdLog Created Successfully');
                return response
            } else {
                //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
                throw new ErrorResponse(11106, 'ProdLog saved but issue while transforming into DTO');
            }

        } catch (error) {
            return error
        }
    }

    async getPrevOperations(lotNumber: string, workstation: number, plantId: number, operation: OperationTypeEnum, inputReq: ProductionInventoryData, status?: FgStatusEnum,columnName?:string): Promise<number> {
        let getWorkCompletedQty
      if(columnName == 'plantId'){

        getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
            .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId')
            .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId} and production_log.sub_plant_id = 0 and workstation='${workstation}' and lot_number='${lotNumber}' and job_status='${JobCompletedEnum.NO}'`)
            .getRawOne()
        }
      if(columnName == 'subPlantId'){
        getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
            .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId')
            .where(`production_log.operation='${operation}' and production_log.sub_plant_id=${plantId} and workstation='${workstation}' and lot_number='${lotNumber}' and job_status='${JobCompletedEnum.NO}'`)
            .getRawOne()
      }

        if (getWorkCompletedQty.productionLogId) {
            return getWorkCompletedQty.productionLogId;
        } else {
            let getWorkDoneQty
            // for different lot prev operation
            if(columnName == 'plantId'){

                getWorkDoneQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId, lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId')
                .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId}  and production_log.sub_plant_id = 0 and workstation='${workstation}' and job_status='${JobCompletedEnum.NO}'`)
                .getRawOne()
            }
            if(columnName == 'subPlantId'){
                getWorkDoneQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId, lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId')
                .where(`production_log.operation='${operation}' and production_log.sub_plant_id=${plantId} and workstation='${workstation}' and job_status='${JobCompletedEnum.NO}'`)
                .getRawOne()
            }

            if (getWorkDoneQty.productionLogId) {
                return getWorkDoneQty.productionLogId
            } else {
                return 0;
            }
        }
    }

    async updatePreviousOperationStatus(lotNumber: string, workstation: number, plantId: number, operation: OperationTypeEnum, inputReq: ProductionInventoryData, status?: FgStatusEnum) {

        const getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
            .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId')
            .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId} and workstation='${workstation}' and lot_number='${lotNumber}' and job_status='${JobCompletedEnum.NO}'`)
            .getRawOne()
        // for same lot prev operation
        if (getWorkCompletedQty.productionLogId) {

            const updateLog = await this.productionLogRepo.update({
                operationType: Raw(
                    (alias) => `operation = '${operation}'`
                ),
                plantId: Raw(
                    (alias) => `plant_id = '${plantId}'`
                ),
                workstation: Raw(
                    (alias) => `workstation = '${workstation}'`
                ),
            }, { jobStatus: JobCompletedEnum.YES });

            if (updateLog.affected) {
                const jobCompletedInputQty = getWorkCompletedQty.quantity;
                const jobCompletedOutputQty = getWorkCompletedQty.outputQuantity;
                const jobCompletedWastageQty = getWorkCompletedQty.wastageQuantity;
                const updateInfo = this.inventoryRepository.updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, OperationTypeEnum.GRADING, inputReq)
            }
            return updateLog.affected;
        } else {
            // for different lot prev operation
            const getWorkDoneQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('round(sum(production_log.input_quantity)) as quantity, round(sum(production_log.actual_output_quantity)) as outputQuantity, round(sum(production_log.wastage_quantity)) as wastageQuantity, production_log_id as productionLogId, lot_number as lotNumber, sub_lot_number as subLotNumber, sale_order_id as saleOrderId, sale_order_item_id as saleOrderItemId')
                .where(`production_log.operation='${operation}' and production_log.plant_id=${plantId} and workstation='${workstation}' and job_status='${JobCompletedEnum.NO}'`)
                .getRawOne()
            if (getWorkDoneQty.productionLogId) {
                const updateLog = await this.productionLogRepo.update({
                    operationType: Raw(
                        (alias) => `operation = '${operation}'`
                    ),
                    plantId: Raw(
                        (alias) => `plant_id = '${plantId}'`
                    ),
                    workstation: Raw(
                        (alias) => `workstation = '${workstation}'`
                    ),
                }, { jobStatus: JobCompletedEnum.YES });



                if (updateLog.affected) {
                    const jobCompletedInputQty = getWorkDoneQty.quantity;
                    const jobCompletedOutputQty = getWorkDoneQty.outputQuantity;
                    const jobCompletedWastageQty = getWorkDoneQty.wastageQuantity;
                    const prevInventory: ProductionInventoryData = inputReq;
                    prevInventory.lotNumber = getWorkDoneQty.lotNumber;
                    prevInventory.subLotNumber = getWorkDoneQty.subLotNumber;
                    prevInventory.saleOrderId = getWorkDoneQty.saleOrderId;
                    prevInventory.saleOrderItemId = getWorkDoneQty.saleOrderItemId;

                    const updateInfo = this.inventoryRepository.updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, OperationTypeEnum.GRADING, prevInventory)
                }
                return updateLog.affected;
            }
            return true;
        }

    }

    async updateBeheadingJobCompleted(productionLogId: number, transManager?: GenericTransactionManager,columnName?:string,opBoxes?:number,outputQuantity?:number): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            let nextOperation
            let getWorkCompletedQty
            getWorkCompletedQty = await this.productionLogRepo.createQueryBuilder('production_log')
                .select('production_log.input_quantity as quantity, production_log.actual_output_quantity as outputQuantity, production_log.wastage_quantity as wastageQuantity, production_log.lot_number as lotNumber, production_log.sub_lot_number as subLotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId, production_log.operation as operation, production_log.plant_id as plantId,production_log.sub_plant_id as subPlantId, production_log.op_boxes as opBoxes')
                .where(`production_log.production_log_id='${productionLogId}'`)
                .getRawOne()
            if (getWorkCompletedQty) {
                const inventoryData = new ProductionInventoryData();
                inventoryData.lotNumber = getWorkCompletedQty.lotNumber;
                inventoryData.subLotNumber = getWorkCompletedQty.subLotNumber;
                inventoryData.saleOrderId = getWorkCompletedQty.saleOrderId;
                inventoryData.saleOrderItemId = getWorkCompletedQty.saleOrderItemId;
                inventoryData.operation = getWorkCompletedQty.operation;
                inventoryData.plantId = getWorkCompletedQty.plantId;
                inventoryData.subPlantId = getWorkCompletedQty.subPlantId;
                inventoryData.opBoxes = opBoxes;
                if(!columnName && getWorkCompletedQty.subPlantId > 0){
                    columnName = 'subPlantId'
                }
                if(!columnName && getWorkCompletedQty.subPlantId == 0){
                    columnName = 'plantId'
                }

                if (getWorkCompletedQty.operation == OperationTypeEnum.VALUE_ADDITION) {
                    const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(getWorkCompletedQty.plantId, getWorkCompletedQty.operation, getWorkCompletedQty.saleOrderItemId));

                    nextOperation = opSequence.data.nextOperation;
                } else {
                    nextOperation = OperationTypeEnum.GRADING
                }


                if (nextOperation) {
                    let updateLog
                    if (transManager) {
                        updateLog = await transManager.getCustomRepository(ProductionLogRepository).update({
                            productionLogId: Raw(
                                (alias) => `production_log_id = '${productionLogId}'`
                            ),
                        }, { jobStatus: JobCompletedEnum.YES });
                    } else {
                        await manager.startTransaction();
                        updateLog = await manager.getCustomRepository(ProductionLogRepository).update({
                            productionLogId: Raw(
                                (alias) => `production_log_id = '${productionLogId}'`
                            ),
                        }, { jobStatus: JobCompletedEnum.YES ,outputBoxes:opBoxes});
                    }


                    if (updateLog.affected) {
                        const jobCompletedInputQty = getWorkCompletedQty.quantity;
                        const jobCompletedOutputQty = getWorkCompletedQty.outputQuantity;
                        const jobCompletedWastageQty = getWorkCompletedQty.wastageQuantity;
                        let updateInfo;
                        if (transManager) {
                            updateInfo = await transManager.getCustomRepository(ProductionInventoryRepository).updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, nextOperation, inventoryData,columnName);
                        } else {
                            updateInfo = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryPhysicalQuantity(jobCompletedInputQty, jobCompletedOutputQty, jobCompletedWastageQty, nextOperation, inventoryData,columnName);
                        }


                        if (updateInfo) {
                            if (!transManager) {
                                await manager.completeTransaction();
                            }
                        } else {
                            await manager.releaseTransaction();
                            throw new ErrorResponse(9999, 'Failed To Report');
                        }
                    } else {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(9999, 'Failed To Report');
                    }
                    return new CommonResponse(true, 1111, 'Job Reported Successfully');
                } else {
                    await manager.releaseTransaction();
                    throw new ErrorResponse(9999, 'No operation sequence found or saleorder');
                }
            } else {
                throw new ErrorResponse(9999, 'Failed To Report');
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error
        }


    }
    async updateOutputGradeAndOperationStatus(productionLogId: number, workStation: number, lotNumber: string, outputGrade: number, outputQuantity: number, nextOperation: OperationTypeEnum,inputQuantity:number): Promise<boolean> {
        const updateInfo = await this.inventoryRepository.updateInventoryOutPutGrade(lotNumber, outputGrade, workStation, outputQuantity, nextOperation,inputQuantity);
        console.log(updateInfo);
        if (updateInfo) {
            const updateLog = await this.productionLogRepo.update({
                productionLogId: Raw(
                    (alias) => `production_log_id = '${productionLogId}'`
                ),
            }, { actualGrade: outputGrade, jobStatus: JobCompletedEnum.YES, actualOutputQuantity: outputQuantity });
            console.log(updateLog);
            if (updateLog.affected > 0) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    async getWorkstationWiseInprogressData(req: OperationRequest): Promise<InProgressBeheadingResponse> {
        try {
            const response = await this.productionLogRepo.getWorkstationWiseInprogressData(req.operationType, req.plantId)
            if (response && response.length) {
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }

    }
    async getBeheadingInventoryData(req: OperationRequest): Promise<BeheadingInventoryResponse> {
        try {
            const response = await this.productionLogRepo.getBeheadingInventoryDetails(req.operationType, req.plantId)
            if (response && response.length) {
                const beheadingData: BeheadingInventoryDto[] = [];
                for (const res of response) {
                    const saleOrderNo = await this.saleOrderService.getSaleOrderDetailsById({ saleOrderId: res.saleOrderId })
                    beheadingData.push(new BeheadingInventoryDto(res.lotNumber, res.saleOrderId, saleOrderNo.data.saleOrder, res.jobNumber, res.subPlant, res.workstationType, res.inputQuantity, res.plannedOutputQuantity, res.boxes, res.workStationId, res.jobStatus, res.createdUser, res.updatedUser));
                }
                console.log(beheadingData);
                return new BeheadingInventoryResponse(true, 1111, 'Beheading inventory information found successfully', beheadingData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getOperationQuantity(lotNumber: string, plantId: number, operation: OperationTypeEnum) {
        const operationQuantity: BeheadingReportedQty = await this.productionLogRepo.getOperationQuantity(lotNumber, plantId, operation)
        return operationQuantity;
    }

    async getExternalPlantInfo(plantId: number, operation: OperationTypeEnum) {
        const externalPlantInfo = await this.productionLogRepo.getExternalPlantInfo(plantId, operation)
        return externalPlantInfo;
    }

    async getAllBeheadingInfo(plantId: number, operation: OperationTypeEnum): Promise<BeheadingDashboardResponse> {
        try {
            const workstationInfo = await this.productionLogRepo.getAllBeheadingInfo(plantId, operation)
            console.log(workstationInfo);
            if (workstationInfo && workstationInfo.length) {
                const categories: string[] = [];
                for (const workstation of workstationInfo) {
                    if (!categories.includes(workstation.workstation))
                        categories.push(workstation.workstation);
                }

                const statuses: string[] = [JobCompletedEnum.NO, JobCompletedEnum.YES];
                const series: Series[] = []

                for (const status of statuses) {
                    const ser = new Series();
                    ser.name = (status == JobCompletedEnum.NO) ? 'In-Progress' : 'Completed';
                    const details: number[] = [];
                    let ifNoData = true;
                    for (const station of categories) {
                        ifNoData = true;
                        for (const inprogress of workstationInfo) {
                            if (status == inprogress.job_status && station == inprogress.workstation) {
                                ifNoData = false;
                                details.push(Number(Number(inprogress.inputQuantity / 1000).toFixed(3)))
                            }
                        }
                        if (ifNoData) {
                            details.push(0);
                        }
                    }
                    ser.data = details;
                    series.push(ser);
                }
                const chartData = new ChartInfo();
                chartData.data = series;
                chartData.xaxis = categories
                return new BeheadingDashboardResponse(true, 1111, 'Beheading inventory information found successfully', chartData);
            } else {
                throw new ErrorResponse(9999, 'No Data Found')
            }

        } catch (error) {
            return error;
        }

    }




    async getLotDetailsById(req: LogIdRequest): Promise<LotDetailsResponseModel> {
        console.log('getLotDetailsByIdService' + req.productionLogid);
        const response = await this.productionLogRepo.getLogDetailsById(req.productionLogid);
        console.log(response,'response??????');
        if (response) {
            const saleOrderNo = await this.saleOrderService.getSaleOrderDetailsForId({ saleOrderId: response.saleOrderId });
            const workStation = await this.workstations.getWorkstationCapacity({ workstationId: response.workStationId, unitId: response.plantId });
            const data = new LogDetailsResponseModelDto(response.productionLogId, response.lotNumber, response.subLotNumber, response.saleOrderId, saleOrderNo.poNumber, response.operation, response.nextOperation, response.inputQuantity, response.plannedGrade, response.soakingTime, response.soakingStyle, response.assignedTime, response.workStationId, workStation.data.workstation, response.saleOrderItemId);
            return new LotDetailsResponseModel(true, 1001, 'Log Details retrived Successfully. ', data);
        }
        else {
            return new LotDetailsResponseModel(false, 1001, 'no data found. ');
        }
    }
    // async getAllSoakingInfos(req: UnitRequest): Promise<SoakingResponseModel> {
    //     try {
    //         const response = await this.productionLogRepo.getSoakingDetails(OperationTypeEnum.SOAKING, req.unitId)
    //         console.log('response..',response)
    //         if (response && response.length) {
    //             const soakingData: SoakingDto[] = [];
    //             for (const res of response) {
    //                 console.log('currentres',res)
    //                 const saleOrderDetails = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId })
    //                 console.log(saleOrderDetails,'sad');
    //                 let saleOrderItemDetails: SaleOrderItemsBySoIdReaponseModel;
    //                 let varient = "";
    //                 console.log(res.saleOrderItemId,'res.saleOrderItemId,,,')
    //                 if (res.saleOrderItemId != null) {
    //                     saleOrderItemDetails = await this.saleOrderService.getSaleOrderItemDetailsBySoItemId({ saleOrderId: res.saleOrderId, saleOrderItemId: res.saleOrderItemId });
    //                     varient = saleOrderItemDetails.data?.variety;
    //                 }
    //                 console.log(res.workStationId,'workStationId///')
    //                 const workStation = await this.workstations.getWorkstationCapacity({ workstationId: res.workStationId, unitId:req.unitId })
    //                 console.log(workStation)
    //                 soakingData.push(new SoakingDto(res.productionLogId, res.jobNumber, res.lotNumber, res.workStationType, res.saleOrderId, saleOrderDetails.saleOrderNumber, varient, res.soakingStyle, res.soakingTime, res.inputQuantity, res.jobStatus, res.assignFreezing, res.shift, res.assignedTime, res.subPlant, res.createdUser, res.workStationId, workStation.data.workstation, res.saleOrderItemId, res.plannedGrade, res.outputGrade, res.operation, 0, ' ', 0, saleOrderDetails.poNumber));
    //             }
    //             return new SoakingResponseModel(true, 1111, 'Soaking inventory information found successfully', soakingData);
    //         } else {
    //             throw new ErrorResponse(9999, 'No Data Found');
    //         }
    //     } catch (error) {
    //         console.log(error,'errorrr--')
    //         return error
    //     }
    // }
    async getAllSoakingInfo(req:UnitRequest):Promise<SoakingResponseModel>{
        const manager = getManager();
        let query
         query ='SELECT  gi.remarks as plantLotNumber,CONCAT(pl.sub_lot_number,IF(gi.remarks IS NOT NULL,"-",""),IF(gi.remarks IS NOT NULL,gi.remarks,"")) as plantAndSubLotNumber,CONCAT(po_number,"-",sk.`variant_code`) AS item,sk.`variant_code` as variantCode,sid.po_number as poNumber,w.workstation,production_log_id AS productionLogId,job_number AS jobNumber,pl.lot_number AS lotNumber,pl.sub_lot_number AS subLotNumber,pl.plant_id AS plantId,workstation_type AS workstationType,pl.workstation AS workstationId,input_quantity AS physicalQuantity,job_status AS jobStatus,pl.sale_order_id AS saleOrderId,pl.sale_order_item_id AS saleOrderItemId,assign_freezing AS assignFreezing,sub_plant_id AS subPlantId,pl.input_quantity AS inputQuantity,pl.planned_output_quantity AS plannedOutputQuantity,pl.soaking_time AS soakingTime,pl.soaking_style AS soakingStyle,shift AS shift,pl.assigned_time AS assignedTime,input_grade AS inputGrade,actual_grade AS outputGrade FROM '+appSettings.production_db+'.`production_log` pl LEFT JOIN '+appSettings.production_db+'.`workstations` w ON w.`workstation_id`=pl.`workstation` LEFT JOIN '+appSettings.sales_db+'.`so_invoice_details` sid ON sid.`sale_order_id`=pl.`sale_order_id`LEFT JOIN '+appSettings.sales_db+'.`sale_order_items` soi ON soi.`sale_order_id`=pl.`sale_order_id` AND soi.`sale_order_item_id`=pl.`sale_order_item_id` LEFT JOIN '+appSettings.masters_db+'.`sku_codes` sk ON sk.`sku_code_id`=soi.`varient_id` LEFT JOIN '+appSettings.rm_procure_db+'.grn_items gi on gi.lot_number=pl.lot_number  where pl.operation="SOAKING" '
         const plantquery = 'select plant_type from ' + appSettings.masters_db + '.unitcodes where unit_code_id='+req.unitId+'';
         const plantdata = await manager.query(plantquery)
         if(plantdata.plant_type == UnitTypeEnum.SUB_PLANT){
            query = query +' and pl.sub_plant_id='+req.unitId+''
         }else{
            query = query+' and pl.plant_id='+req.unitId+' and pl.sub_plant_id=0'
         }
        const result = await manager.query(query);
        if(result){
            return new SoakingResponseModel(true, 1111, 'Soaking inventory information found successfully', result);
        }
        else{
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getAllBeheadingInProgressJobs(unitId: number, operation: OperationTypeEnum): Promise<InProgressBeheadingResponse> {
        try {
            const manager = getManager();
            const PlantTypeQuery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+unitId;
            const result =await manager.query(PlantTypeQuery);
            var query = `SELECT gi.remarks as plantLotNumber,CONCAT(gi.lot_number,IF(gi.remarks IS NOT NULL,'-',''),IF(gi.remarks IS NOT NULL,gi.remarks,'')) as lotandplantlot,log.production_log_id as productionLogId, log.lot_number as lotNumber, log.sub_lot_number as subLotNumber, log.workstation_type as workstationType, w.workstation as workstation, round(log.input_quantity) as quantity, log.operation, log.plant_id as plantId, log.sub_plant_id as subPlantId, log.created_user as createdUser, log.updated_user as updatedUser,log.assigned_time as assignedTime, job_status as jobStatus, log.job_number as jobNumber, log.dc_number as dcNumber, log.mrn_number as mrnNumber, log.sale_order_id as saleOrderId, log.sale_order_item_id as saleOrderItemId, log.ip_boxes as ipBoxes, log.actual_output_quantity as physicalQuantity, sku.variant_code as varietyOfMaterial, si.varient_id as variety , log.op_boxes AS opBoxes, w.workstation_unit_capacity AS workstationCapacity
               FROM `+ appSettings.production_db + `.production_log log 
              LEFT JOIN `+ appSettings.production_db + `.workstations w ON log.workstation=w.workstation_id
              LEFT JOIN `+ appSettings.sales_db + `.sale_order_items si ON si.sale_order_item_id=log.sale_order_item_id
              LEFT JOIN `+ appSettings.masters_db + `.sku_codes sku ON sku.sku_code_id=si.varient_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on log.lot_number=gi.lot_number where
              log.operation='${operation}' and job_status='${JobCompletedEnum.NO}' and workstation_type='${WorkStationTypeEnum.INTERNAL}'`
              if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
                query+="AND log.sub_plant_id="+unitId;
              }else{
                query+="AND log.plant_id="+unitId+' and log.sub_plant_id = 0';
              }
            const response = await manager.query(query);
            // const response = await this.productionLogRepo.getAllBeheadingInProgressJobs(operation, unitId)
            if (response?.length) {
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }


    async getAllBeheadingExternalPlantJobs(unitId: number, operation: OperationTypeEnum): Promise<InProgressBeheadingResponse> {
        try {
            const response = await this.productionLogRepo.getAllBeheadingExternalPlantJobs(operation, unitId)
            if (response && response.length) {
                for (const res of response) {
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId })

                    res.saleOrder = (saleOrderDetails) ? saleOrderDetails.saleOrderNumber : '';
                    res.poNumber = (saleOrderDetails) ? saleOrderDetails.poNumber : '';

                }
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getAllExternalPlantLots(unitId: number): Promise<CommonResponse> {
        try {
            const response = await this.productionLogRepo.getAllExternalPlantLots(unitId)
            if (response && response.length) {
                for (const res of response) {
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderDetailsById({ saleOrderId: res.saleOrderId })
                    res.saleOrder = saleOrderDetails.data.saleOrder;
                }
                return new CommonResponse(true, 1111, 'External Plant Info found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }


    async getAllBeheadingPlantJobs(unitId: number, operation: OperationTypeEnum): Promise<InProgressBeheadingResponse> {
        try {
            const response = await this.productionLogRepo.getAllBeheadingPlantJobs(operation, unitId)
            if (response && response.length) {
                for (const res of response) {
                    const saleOrderDetails = await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: res.saleOrderId })
                    res.saleOrder = saleOrderDetails.saleOrderNumber;
                    res.poNumber = saleOrderDetails.poNumber;
                }
                return new InProgressBeheadingResponse(true, 1111, 'Beheading information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    // async getAllOperationReports(req?: OperationRegisterRequest): Promise<OperationsRegisterResponseModel> {
    //     try {
    //         let operatonsRegisterDto: OperatonsRegisterDto[] = [];
    //         // retrieves all plants
    //         // const operationRegisterDetails : OperationRegisterDTO[] = await this.productionLogRepository.find({
    //         //     order: { createdAt: "DESC" },
    //         // });


    //         const operationRegisterDetails = await this.productionLogRepository.createQueryBuilder("ProductionLog")
    //             .leftJoinAndSelect('ProductionLog.workstation', 'workstation')
    //             .getMany();

    //         if (operationRegisterDetails.length > 0) {
    //             let soNumber = null;
    //             for (const entity of operationRegisterDetails) {

    //                 const soData = (await this.saleOrderService.getSaleOrderDataForSoId({ saleOrderId: entity.saleOrderId }));

    //                 if (soData.saleOrderId > 0) {
    //                     soNumber = soData.saleOrderNumber ? soData.saleOrderNumber : ''
    //                 }
    //                 //soNumber= "hello";
    //                 const operationregisterData: OperatonsRegisterDto =
    //                     //new OperatonsRegisterDto(1,"lot number",'1',3,"abc",1,"op","job no",1,"workstaton type",JobStatusEnum.DONE,"workstation",1,3,2,11,11,11,11,11,"me","12:30",1,ShiftsEnum.General,"me","me");
    //                     new OperatonsRegisterDto(entity.productionLogId, entity.lotNumber, entity.subLotNumber, entity.saleOrderId, soNumber, entity.saleOrderItemId, entity.operationType, entity.jobNumber, entity.subPlantId, entity.workStationType, entity.jobStatus, (entity.workstation) ? entity.workstation.workstation : '', entity.inputGrade, entity.plannedGrade, entity.actualGrade, entity.inputQuantity, entity.plannedOutputQuantity, entity.actualOutputQuantity, entity.inputBoxes, entity.outputBoxes, entity.assignedUser, entity.assignedTime, entity.plantId, entity.shift, entity.createdUser, entity.updatedUser);

    //                 // console.log(stockDtoData)
    //                 operatonsRegisterDto.push(operationregisterData);
    //             };
    //             // console.log(operatonsRegisterDto)

    //             if (operatonsRegisterDto) {
    //                 const response = new OperationsRegisterResponseModel(true, 11208, "Data Retrived successfully", operatonsRegisterDto);
    //                 return response;
    //             }
    //         } else {
    //             throw new ErrorResponse(99998, 'No Records Found');
    //         }
    //     } catch (err) {
    //         return err;
    //     }
    // }
    async getAllOperationReports(req?:OperationRegisterRequest):Promise<CommonResponse>{
        try{
          const manager = getManager();
          let query = "SELECT lot_number as lotNumber,sub_lot_number as subLotNumber,so.sale_order_no as saleOrderNumber,operation,sub_plant_id as subPlantId,job_number as jobNumber,workstation_type as workstationType,w.workstation,input_grade as inputGrade,planned_grade as plannedGrade,actual_grade as actualGrade,input_quantity as inputQuantity,planned_output_quantity as plannedOutputQuantity,actual_output_quantity as actualOutputQuantity,ip_boxes as ipBoxes,op_boxes as opBoxes,shift FROM `erpx_dev_production`.`production_log` p LEFT JOIN `erpx_dev_sales`.`sale_order` so ON so.sale_order_id = p.sale_order_id LEFT JOIN `erpx_dev_production`.`workstations` w ON  w.workstation_id = p.workstation"
    
        //   if(req.unitId && req.unitId != 5){
        //     if(req.lotNumber == undefined && req.fromDate == undefined && req.toDate == undefined){
        //     query = query+  'and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id';
    
        //     }
        //     if(req.lotNumber){
        //       query=query+' AND pl.lot_number = "'+req.lotNumber+'" and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id'
        //     }
        //     if(req.fromDate && req.toDate){
        //         query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id';
        //     }
        //     if(req.lotNumber && req.fromDate && req.toDate){
        //         query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber+'" and pl.plant_id = '+req.unitId+' GROUP BY pl.lot_number,pl.sale_order_item_id' ;
        //     }
        //   }
        //   else{
        //        if(req.lotNumber){
        //       query=query+' AND pl.lot_number= "'+req.lotNumber+'" GROUP BY pl.lot_number,pl.sale_order_item_id';
        //     }
        //     if(req.fromDate && req.toDate){
        //         query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'"GROUP BY pl.lot_number,pl.sale_order_item_id' ;
        //     }
        //     if(req.lotNumber && req.fromDate && req.toDate){
        //       query=query+' And DATE(pl.created_at) BETWEEN  "'+req.fromDate+'" and "'+req.toDate+'" and pl.lot_number= "'+req.lotNumber+'" GROUP BY pl.lot_number,pl.sale_order_item_id' ;
        //   }
        //   }
         
          const data=await manager.query(query)      
    
          if(data.length > 0){
            return new CommonResponse(true,1001,"Lots retrieved successfully. ",data);
          }
          else{
            return new CommonResponse(false,1010,"No data found. ");
          }
        }
        catch(err){
          return err
        }
      }
    

    async getLogDetailsForId(productionLogId: number): Promise<SubPlantTransferResponse> {
        try {
            const response = await this.productionLogRepo.getLogDetailsForId(productionLogId)
            if (response) {
                // const saleOrderDetails = await this.saleOrderService.getSaleOrderDetailsById({ saleOrderId: res.saleOrderId })
                // response.saleOrder =saleOrderDetails.data.saleOrder;
                if (response.itemId != null) {
                    const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({ saleOrderItemId: response.itemId })
                    console.log(soItemInfo);
                    response.itemName = soItemInfo.data.product;
                }
                return new SubPlantTransferResponse(true, 1111, 'Transfer information found successfully', response);
            } else {
                throw new ErrorResponse(9999, 'No Data Found');
            }
        } catch (error) {
            return error
        }
    }

    async getLotTrackingReportData(req: LotInfoRequest): Promise<LotNumberReportResponseModel> {

        const lotDetails = await this.productionLogRepo.getLotInformation(req);
        console.log('lotDetails' + lotDetails);
        const responseData: LotTrackingResponseDto[] = [];
        for (const lot of lotDetails) {
            console.log(lot);
            const workStation = await this.workstations.getWorkstationCapacity({ workstationId: lot.workstation, unitId: lot.plantId });
            console.log(workStation.data);
            const data = new LotTrackingResponseDto(lot.lotNumber, lot.inputQuantity, lot.plannedOutputQuantity, workStation.status ? workStation.data.workstation : "", lot.operation, lot.jobNumber, lot.jobStatus, lot.assignedTime);
            responseData.push(data);
        }
        return new LotNumberReportResponseModel(true, 1001, "lot details retrived successfully. ", responseData);
    }
    async getSubPlantHistoryDetails(req: UnitRequest): Promise<ProductionLogDetailsResponseModel> {
        try {
            // const subPlantData = await this.productionLogRepo.getSubPlantHistory(req.unitId);
            // console.log(subPlantData);
            // if (subPlantData.length && subPlantData) {
            //     const logData: SubPlantHistoryDto[] = [];
            //     for (const lot of subPlantData) {
            //         const soData = (await this.saleOrderService.getSaleOrderFewDetailsForSoId({ saleOrderId: lot.saleOrderId }));
            //         const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: lot.plantId });
            //         const plantName = plantDetails.status ? plantDetails.data.unitcodeName : "";
            //         const subPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: lot.subPlantId });
            //         const subPlantName = subPlantDetails.status ? subPlantDetails.data.unitcodeName : "";
            //         const data = new SubPlantHistoryDto(lot.productionLogId, lot.operationType, lot.lotNumber, lot.subLotNumber, lot.jobNumber, lot.saleOrderId, lot.saleOrderItemId, lot.plantId, lot.subPlantId, lot.workStationType, lot.jobStatus, lot.assignFreezing, lot.workstation, lot.inputGrade, lot.plannedGrade, lot.actualGrade, lot.inputQuantity, lot.plannedOutputQuantity, lot.actualOutputQuantity, lot.inputBoxes, lot.outputBoxes, lot.assignedUser, lot.assignedTime, lot.shift, lot.isReceived, lot.operation, soData.saleOrderNumber, plantName, subPlantName, lot.wipQuantity, soData.poNumber);
            //         logData.push(data);
            //     }

                const manager = getManager();
                const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId;
                const result =await manager.query(query);
                //  var dataQuery = `SELECT production_log_id as productionLogId,job_number as jobNumber, workstation as workstation, production_log.input_grade as inputGrade, (production_log.input_quantity) as inputQuantity, job_status as jobStatus, production_log.operation as operationType,CONCAT(production_log.lot_number , " - ",gi.remarks) as lotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId, (production_log.op_boxes) as opBoxes, assigned_time as assignedTime, production_log.sub_lot_number as subLotNumber, production_log.plant_id as plantId, production_log.sub_plant_id as subPlantId,production_log.workstation_type as workStationType, production_log.assign_freezing as assignFreezing,planned_grade as plannedGrade , actual_grade as actualGrade, (planned_output_quantity) as plannedOutputQuantity,(actual_output_quantity) as actualOutputQuantity, (ip_boxes) as inputBoxes,(production_log.op_boxes) as outputBoxes, assigned_user as assignedUser,assigned_time as assignedTime, shift as shift, sub_plant_op_status as isReceived, production_log.operation, productionInventory.wip_quantity as wipQuantity,sid.po_number as poNumber , uc.unit_name as plantName , ucs.unit_name as subPlantName FROM ` + appSettings.production_db + `.production_log production_log LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number = production_log.lot_number LEFT JOIN ` + appSettings.production_db + `.production_inventory productionInventory ON productionInventory.prod_inv_id = production_log.prod_inv_id LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = production_log.sale_order_id LEFT JOIN `+appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = production_log.plant_id LEFT JOIN `+appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = production_log.sub_plant_id  WHERE production_log.workstation_type = '${WorkStationTypeEnum.EXTERNAL}' `
                var dataQuery = `SELECT pi.operation, stl.send_boxes as inputBoxes,receive_boxes as outputBoxes,pi.wip_quantity as wipQuantity,pi.physical_quantity AS inputQuantity, uc.unit_name as plantName , ucs.unit_name as subPlantName, CONCAT(pi.lot_number,"-",gi.remarks) as lotNumber,sid.po_number as poNumber from `+appSettings.production_db+`.stock_transfer_log stl LEFT JOIN `+appSettings.production_db+`.production_inventory pi on pi.prod_inv_id = stl.new_production_inv_id LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number = pi.lot_number LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = pi.sale_order_id LEFT JOIN `+appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = pi.plant_id LEFT JOIN `+appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = stl.sub_plant_id where stl.transfer_log_id > 0 `;
                //  if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
                //     dataQuery += "AND stl.sub_plant_id="+req.unitId;
                //   }else{
                    dataQuery += " AND stl.plant_id="+req.unitId;
                //   }
                  const subPlantHistory =await manager.query(dataQuery);
                  
                  if(subPlantHistory.length > 0) {
                      const response = new ProductionLogDetailsResponseModel(true, 1001, 'ProdLog Created Successfully', subPlantHistory);
                      return response;
                  }
                  else {
                const response = new ProductionLogDetailsResponseModel(false, 1010, 'No Data Found. ');
                return response;
            }
        }
        catch (error) {
            return error
        }
    }

    async getTransactionDetails(req: UnitRequest): Promise<CommonResponse> {
        try {
                const manager = getManager();
                const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+req.unitId;
                const result =await manager.query(query);
                 var dataQuery = `SELECT production_log_id as productionLogId,job_number as jobNumber, workstation as workstation, production_log.input_grade as inputGrade, (production_log.input_quantity) as inputQuantity, job_status as jobStatus, production_log.operation as operationType, concat(production_log.lot_number,"-",gi.remarks) as lotNumber, production_log.sale_order_id as saleOrderId, production_log.sale_order_item_id as saleOrderItemId, (production_log.op_boxes) as opBoxes, assigned_time as assignedTime, production_log.sub_lot_number as subLotNumber, production_log.plant_id as plantId, production_log.sub_plant_id as subPlantId,production_log.workstation_type as workStationType, production_log.assign_freezing as assignFreezing,planned_grade as plannedGrade , actual_grade as actualGrade, (planned_output_quantity) as plannedOutputQuantity,(actual_output_quantity) as actualOutputQuantity, (ip_boxes) as inputBoxes,(production_log.op_boxes) as outputBoxes, assigned_user as assignedUser,assigned_time as assignedTime, shift as shift, sub_plant_op_status as isReceived, production_log.operation, productionInventory.wip_quantity as wipQuantity,sid.po_number as poNumber , uc.unit_name as fromPlantName , ucs.unit_name as toPlantName FROM ` + appSettings.production_db + `.production_log LEFT JOIN `+appSettings.rm_procure_db+`.grn_items gi on gi.lot_number = production_log.lot_number LEFT JOIN ` + appSettings.production_db + `.production_inventory productionInventory ON productionInventory.prod_inv_id = production_log.prod_inv_id LEFT JOIN  `+ appSettings.sales_db + `.so_invoice_details sid ON sid.sale_order_id = production_log.sale_order_id LEFT JOIN `+appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id = production_log.plant_id LEFT JOIN `+appSettings.masters_db + `.unitcodes ucs ON ucs.unit_code_id = production_log.sub_plant_id  WHERE production_log.production_log_id > 0 ' `
                 if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
                    dataQuery += "AND production_log.sub_plant_id="+req.unitId;
                  }else{
                    dataQuery += "AND production_log.plant_id="+req.unitId+' and production_log.sub_plant_id = 0';
                  }
                  const subPlantHistory =await manager.query(dataQuery);
                  
                  if(subPlantHistory.length > 0) {
                      const response = new ProductionLogDetailsResponseModel(true, 1001, 'ProdLog Created Successfully', subPlantHistory);
                      return response;
                  }
                  else {
                const response = new ProductionLogDetailsResponseModel(false, 1010, 'No Data Found. ');
                return response;
            }
        }
        catch (error) {
            return error
        }
    }
}
